import { css } from "@compiled/react";
import { FormattedMessage, useIntl } from "react-intl";

import { media } from "@atlaskit/primitives";

import { Picture } from "@/components/wpl/image/src";
import { Row } from "@/libraries/wpl/foundations/src";

const sectionStyle = css({
    marginBlock: "2rem 2rem",
    textAlign: "center"
});

const bodyStyle = css({
    color: "#091e42",
    fontWeight: 600
});

const logosGridStyle = css({
    display: "flex",
    gap: "2.5rem",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
    margin: "auto",
    padding: "0 0 1rem 0",
    listStyle: "none",

    [media.below.xs]: {
        flexDirection: "column"
    },

    /* fix width to ensure last logo does not appear on its own line by itself */
    [media.only.xs]: {
        maxWidth: "30rem"
    },
    [media.above.sm]: {
        flexWrap: "nowrap"
    }
});

const liStyle = css({
    margin: 0
});

const CustomersSection = () => {
    const intl = useIntl();

    const logos = [
        {
            src: "https://wac-cdn.atlassian.com/dam/jcr:cdfc6c3f-7185-4a73-b09f-4752ba9ce044/Sqaure.svg?cdnVersion=1437",
            alt: intl.formatMessage({
                id: "JiraProductDiscoveryPage.customers.squareAlt",
                defaultMessage: "Square logo"
            }),
            width: 150
        },
        {
            src: "https://wac-cdn.atlassian.com/dam/jcr:fade38f9-9645-4a97-8349-d1be742ce2a3/Ebay.svg?cdnVersion=1437",
            alt: intl.formatMessage({
                id: "JiraProductDiscoveryPage.customers.ebayAlt",
                defaultMessage: "eBay logo"
            }),
            width: 95
        },
        {
            src: "https://wac-cdn.atlassian.com/dam/jcr:d9ac494f-ca27-4c43-8012-d150469a1178/Cisco.svg?cdnVersion=1437",
            alt: intl.formatMessage({
                id: "JiraProductDiscoveryPage.customers.ciscoAlt",
                defaultMessage: "Cisco logo"
            }),
            width: 90
        },
        {
            src: "https://wac-cdn.atlassian.com/dam/jcr:a043a0f2-c98b-4910-8ed1-d5368068e05d/Dropbox.svg?cdnVersion=1437",
            alt: intl.formatMessage({
                id: "JiraProductDiscoveryPage.customers.dropboxAlt",
                defaultMessage: "Dropbox logo"
            }),
            width: 159
        }
    ];

    return (
        <div css={sectionStyle}>
            <Row layout="12">
                <p css={bodyStyle}>
                    <FormattedMessage
                        id="JiraProductDiscoveryPage.customers.socialproof"
                        defaultMessage="Join the 100,000 customers worldwide who trust Jira"
                    />
                </p>
            </Row>
            <Row layout="12">
                <ul css={logosGridStyle}>
                    {logos.map((logo) => (
                        <li key={logo.src} css={liStyle}>
                            <Picture image={{ ...logo, loading: "lazy" }} />
                        </li>
                    ))}
                </ul>
            </Row>
        </div>
    );
};

export default CustomersSection;
